import { FormLabel, styled, type FormLabelProps } from "@mui/material";

export const StyledFormLabel = styled(FormLabel, {
	shouldForwardProp: (prop) => prop !== "color",
})<FormLabelProps>(({ theme, color }) => ({
	color: color ?? theme.palette.text.primary,
	fontWeight: "bold",
	marginBottom: theme.spacing(0.25),
}));
